import { TermAndConditionList } from '../../assets/api/useMarketingExecutive';
import { Typography } from '@mui/material';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';

const PayoutTable = ({ id }) => {
    const { data: termConditionList, isLoading: isTermConditionLaoding } = TermAndConditionList({ apartment_id: id })
    const payoutRows = termConditionList?.student_payouts?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || []
    const payoutColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },

        {
            field: "course_name",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "from_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
         {
            field: "to_date",
            headerName: "To Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "payout_type",
            headerName: "Payout Type",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },
        {
            field: "percentage",
            headerName: "Percentage",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },

        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },
    ];
    return (
        <>
            <TableFilterTemplate
                title="Payouts"
                columns={payoutColumn}
                rowsData={payoutRows || []}
                isLoading={isTermConditionLaoding}
            />
        </>
    )
}

export default PayoutTable